import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StackedRibbonList, RibbonColumn } from '@tanium/react-stacked-ribbon-list';
import { Tag } from 'gql/Common';

export interface ITagsProps {
  tags: Tag[] | null | undefined;
}

export const TagsDisplay = ({ tags }: ITagsProps): React.ReactElement => {
  const { t } = useTranslation();

  const columns: RibbonColumn<Tag>[] = [
    {
      label: t('KEY'),
      dataKey: 'key',
      isSortDisabled: true,
      width: 200,
    },
    {
      label: t('VALUE'),
      dataKey: 'value',
      isSortDisabled: true,
    },
  ];

  const dataGetter = useCallback((index: number) => tags![index], [tags]);
  const itemIdGetter = useCallback((index) => `${index}-${dataGetter(index).key}`, [dataGetter]);

  return tags?.length ? (
    <StackedRibbonList
      columns={columns}
      width={600}
      height={`${tags.length * 31 + 32}px`}
      dataGetter={dataGetter}
      itemIdGetter={itemIdGetter}
      isItemLoaded={(): boolean => true}
      itemCount={tags.length}
    />
  ) : (
    <></>
  );
};

export default TagsDisplay;
